import type { SaveClientFlags, UserSettings } from '@sdk/authentication/types';
import { ShiftAlarmsModel } from '@sdk/shifts/types/shiftAlarmsType';

import type { ClientSettingsType } from '../types';
import { WebNotificationType } from '../types';

type Props = {
  userSettings: UserSettings;
  clientSettings: ClientSettingsType;
  alarmsModel: ShiftAlarmsModel;
  saveClientFlags: SaveClientFlags;
};
const preSaveUserSettingsHandler = ({
  userSettings,
  clientSettings,
  alarmsModel,
  saveClientFlags,
}: Props): UserSettings => {
  const updatedUserSettings = { ...userSettings };
  const {
    messagesNotify,
    messagesNotifyViaEmail,
    messagesNotifyViaPush,
    newsfeedNotify,
    newsfeedNotifyViaEmail,
    newsfeedNotifyViaPush,
    shiftAlarmNotifyViaSms,
    shiftAlarmNotifyViaPush,
    shiftAlarmNotifyViaEmail,
  } = updatedUserSettings;

  if (
    messagesNotify !== 0 &&
    !messagesNotifyViaEmail &&
    !messagesNotifyViaPush &&
    !clientSettings[WebNotificationType.notifications]
  ) {
    updatedUserSettings.messagesNotify = 0;
  }

  if (
    newsfeedNotify !== 0 &&
    !newsfeedNotifyViaEmail &&
    !newsfeedNotifyViaPush &&
    !clientSettings[WebNotificationType.newsfeedNotifications]
  ) {
    updatedUserSettings.newsfeedNotify = 0;
  }

  if (!shiftAlarmNotifyViaSms && !shiftAlarmNotifyViaPush && !shiftAlarmNotifyViaEmail) {
    updatedUserSettings.shiftAlarmEnabled = false;
  }

  delete updatedUserSettings.shiftAlarmMinutesBefore;

  const sortedAlarms = alarmsModel.sort((a, b) => a.value - b.value);
  const sortedAlarmsUnits = sortedAlarms.map((alarm) => alarm.unit.value);
  updatedUserSettings.shiftAlarms = sortedAlarms.map((alarm) => alarm.value);
  updatedUserSettings.clientFlags.shiftAlarmsUnits = sortedAlarmsUnits;
  saveClientFlags({
    flags: { shiftAlarmsUnits: sortedAlarmsUnits },
  });

  return updatedUserSettings;
};

export default preSaveUserSettingsHandler;
